<template>
    <MobileLoader :is-visible="storeUI.isMobileLoader"/>
</template>

<script>
import { $ } from '@/Engine/state';
import { parseConfigStringToJSON, parseToolChestStringToJSON } from '@/libs/parseQueryConfig';
import { casesLib } from '@/Constants/casesLib';
import { storeConfigurationUpdate } from '@/Engine/app';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { useStoreUI } from '@/Store/storeUI';
import MobileLoader from '@/UI/Mobile/MobileLoader.vue';

export default {
    name: 'TheMobile',
    components: { MobileLoader },
    setup() {
      const storeCaseConfiguration = useStoreCaseConfiguration();
      const storeProjectStructure = useStoreProjectStructure();
      const storeUI = useStoreUI();

      return {
        storeCaseConfiguration,
        storeProjectStructure,
        storeUI,
      };
    },
    mounted: async function() {
      await this.parseQueryConfig();
      $.initConfigurator = true;
      await storeConfigurationUpdate(this.storeCaseConfiguration.$state);

    },
    methods: {
      async parseQueryConfig() {
        const dataInCaseItems = this.$route.query?.config;
        const dataInToolChest = this.$route.query?.toolChest;
        console.log(dataInCaseItems);
        console.log(dataInToolChest);
        if (!dataInCaseItems && !dataInToolChest) {
          return;
        }

        let dataOutCaseItems = parseConfigStringToJSON(dataInCaseItems);
        let dataOutToolChest = parseToolChestStringToJSON(dataInToolChest);
        const actualToolChest = casesLib.find(x => x.id === dataOutToolChest.blenderName);
        this.storeCaseConfiguration.$patch({
          caseItems: dataOutCaseItems,
          blenderName: dataOutToolChest.blenderName,
          selectedCaseModel: actualToolChest?.key,
          colorFrame: dataOutToolChest.colorFrame,
          colorFace: dataOutToolChest.colorFace,
          isCloseDoors: dataOutToolChest.isCloseDoors,
          drawerSeparators: dataOutToolChest.drawerSeparators,
          expandedDrawersPrototypeId: dataOutToolChest.expandedDrawersPrototypeId,
        });
        console.log('patched by URL config', this.storeCaseConfiguration.$state);
      },
    },
};
</script>

<style scoped lang="scss">
</style>
